const filters = {
  btnFilters: 'Filtros',
  titleDropdown: 'Filtros rápidos',

  filterDate: {
    today: 'Hoje',
    tomorrow: 'Amanhã',
    yesterday: 'Ontem',
    lastWeek: 'Semana Passada',
    lastMonth: 'Mês Passado',
    customRange: 'Intervalo personalizado',
    overLimit: 'Por favor, selecione um intervalo de {{limit}} dias ou menos',
    fromTime: 'Horário Inicial',
    toTime: 'Horário Final',
  },
};

export default filters;
